/*
 * @Date: 2022-08-22 17:53:11
 * @LastEditors: kinfai
 * @Description: home
 * @LastEditTime: 2022-08-29 10:36:54
 * @FilePath: \my-app\src\pages\SetupBtn\index.jsx
 */
import "./index.less";
import AliIcon from "../../components/AliIcon";
import useChatPlugin from "@/hooks/chatPlugin/index.js";


export default function SetupBtn(props) {
    const {getPluginConfig} = useChatPlugin()
    const pgConfig = getPluginConfig()

    return (
        <div onClick={props.handleToggle} className="g-setup-btn"
        style={{
            backgroundColor: pgConfig.btnColor
        }}
        >
            {props.status === false ? (
                <AliIcon type="icon-chat-voice-fill" size="32px" style={{
                    color: 'white'
                }}></AliIcon>
            ) : (
                <AliIcon type="icon-close-bold" size="35px" style={{color: 'white'}}></AliIcon>
                // <span className="s-close-text">X</span>
            )}
        </div>
    );
}
